import type { CreditTopupLimits } from "@/lib/credit-topup";

export const CREDITS_DEBT_ROUNDING_COP = 1000;

export interface CreditsDebt {
  owedCop: number;
  priceCop: number | null;
}

export function hasCreditsDebt(debt: CreditsDebt | null | undefined): debt is CreditsDebt {
  return !!debt && Number.isFinite(debt.owedCop) && debt.owedCop > 0;
}

export function creditsDebtTopupCop(debt: CreditsDebt, limits: Pick<CreditTopupLimits, "minCop" | "maxCop">): number {
  const needed = Math.max(0, debt.owedCop) + Math.max(0, debt.priceCop ?? 0);
  const rounded = Math.ceil(needed / CREDITS_DEBT_ROUNDING_COP) * CREDITS_DEBT_ROUNDING_COP;
  return Math.min(Math.max(rounded, limits.minCop), limits.maxCop);
}
